// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 188 ? "Body-Body" : chunkId) + "." + {"103":"19a5892fdef94f41bc83","188":"698fb4142e67e0141d2a"}[chunkId] + ".bundle.js";
};